import * as bootstrap from 'bootstrap'
import { initializeApp } from 'firebase/app'
import { getAuth, signInWithEmailAndPassword } from "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyCtSfIQyZua3V5lpmthL-Q49trkv9phV4g",
  authDomain: "webstructrual.firebaseapp.com",
  databaseURL: "https://webstructrual.firebaseio.com",
  projectId: "webstructrual",
  storageBucket: "webstructrual.appspot.com",
  messagingSenderId: "157062586915"
}

initializeApp(firebaseConfig)

//https://www.freecodecamp.org/news/reusable-html-components-how-to-reuse-a-header-and-footer-on-a-website/
class LoginModalComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-login-form" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <h3><i class="fa fa-sign-in fa-3x"></i></h3>
              <h2 class="text-center">Sign In</h2>
            </div>
            <div id="modal-sign-in-error" class="alert alert-danger d-none"></div>
            <form>
              <fieldset>
                <div class="input-group" style="padding-bottom: 10px;">
                  <span class="input-group-text"><i class="fa fa-envelope color-blue"></i></span>
                  <input id="sign-in-email" name="email" placeholder="Email Address" class="form-control" type="email"
                    aria-label="email" aria-describedby="E-Mail" autocomplete="email">
                </div>
    
                <div class="input-group" style="padding-bottom: 10px;">
                  <span class="input-group-text"><i class="fa fa-lock color-blue"></i></span>
                  <input type="password" class="form-control" placeholder="Password" name="password" value=""
                    aria-label="password" aria-describedby="Password" autocomplete="current-password" id="sign-in-password">
                </div>
    
                <div class="d-grid gap-2" style="padding-bottom: 10px;">
                  <!-- Change this to a button or input when using this as a form -->
                  <a href="#" class="btn btn-lg btn-success btn-block" id="modal-login-login-button">
                    <span id="login-wait-spinner"
                      class="spinner-border spinner-border-sm d-none"></span>
                    Login
                  </a>
                </div>
    
                <div class="d-grid gap-2" style="padding-bottom: 10px;">
                  <a href="#" class="btn btn-default btn-sm" data-bs-dismiss="modal" data-bs-toggle="modal"
                    data-bs-target="#modal-sign-up-form">Create an account</a>
                </div>
    
                <div class="d-grid gap-2 text-center" style="padding-bottom: 10px;">
                  <small>
                    <a href="#" data-bs-dismiss="modal" id="modal-login-forgot-password-button" data-bs-toggle="modal"
                      data-bs-target="#modal-forgot-password-form">
                      Forgot password
                    </a>
                  </small>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>`

    document.getElementById('modal-login-login-button').addEventListener('click', this.login)
  }

  login() {
    let email = document.getElementById('sign-in-email').value.trim()
    let password = document.getElementById('sign-in-password').value.trim()

    document.getElementById('login-wait-spinner').classList.remove('d-none')
    document.getElementById('modal-sign-in-error').innerHTML = ''
    document.getElementById('modal-sign-in-error').classList.add('d-none')

    signInWithEmailAndPassword(getAuth(), email, password)
      .then(function () {
        document.getElementById('login-wait-spinner').classList.add('d-none')
        document.getElementById('modal-sign-in-error').innerHTML = ''
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-login-form')).hide()
        // handle login logic (configuration) in app.js "auth.onAuthStateChanged"        
      })
      .catch((error) => {
        console.error(error)
        let errorCode = error.code
        let errorMessage = error.message

        let str = errorMessage
        if (errorCode === 'auth/missing-email') {
          str = 'Email is required.'
        }
        if (errorCode === 'auth/wrong-password') {
          str = 'Invalid password.'
        }
        if(errorCode === 'auth/user-not-found') {
          str = 'User not found.'
        }

        document.getElementById('login-wait-spinner').classList.add('d-none')
        document.getElementById('modal-sign-in-error').innerHTML = str
        document.getElementById('modal-sign-in-error').classList.remove('d-none')
      })
  }
}

customElements.define('login-modal-component', LoginModalComponent)